module.exports = __webpack_public_path__ + "./images/3dfe94b53ad5bb3389ca7d508a9c981f.webp";